import React, { FC } from 'react';
import { StatsContainer } from './Statistics.style';

export const StatisticLoader: FC = () => (
	<StatsContainer className="flex flex-row items-center justify-between rounded-3xl border bg-white">
		{Array.from(new Array(4)).map((ele, i) => (
			<div key={i} role="status" className="max-w-sm animate-pulse rounded">
				<div className="flex flex-col items-start justify-center gap-2 space-x-3">
					<div className="ml-2 h-14 w-14 rounded-2xl bg-gray-200 2xl:h-20 2xl:w-20"></div>
					<div className="flex flex-col items-start justify-center">
						<div className="mb-2 h-2.5 w-20 rounded-full bg-gray-200 dark:bg-gray-700 2xl:w-36"></div>
						<div className="flex flex-row gap-2">
							<div className="h-2 w-12 rounded-full bg-gray-200 dark:bg-gray-700 2xl:w-24"></div>
							<div className="h-2 w-7 rounded-full bg-gray-200 dark:bg-gray-700 2xl:w-10"></div>
						</div>
					</div>
				</div>
			</div>
		))}
	</StatsContainer>
);
